import { useEffect, useState } from "react";
import api from "../../api/api";

export default function BillingAnalyticsPage() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/stripe/analytics")
            .then((res) => setData(res.data));
    }, []);

    if (!data) return <p>Loading analytics...</p>;

    return (
        <div className="p-6 bg-white rounded shadow">
            <h1 className="text-2xl font-bold mb-4">Billing Analytics</h1>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <div className="border p-4 rounded">
                    <b>Total Revenue</b>
                    <p>{data.totalRevenue} EUR</p>
                </div>

                <div className="border p-4 rounded">
                    <b>Pending Amount</b>
                    <p>{data.pendingAmount} EUR</p>
                </div>

                <div className="border p-4 rounded">
                    <b>Total Payments</b>
                    <p>{data.totalPayments}</p>
                </div>

                <div className="border p-4 rounded">
                    <b>Completed</b>
                    <p>{data.completedPayments}</p>
                </div>
            </div>

            <h2 className="text-xl font-bold mb-2">Monthly Revenue</h2>
            <h2 className="text-xl font-bold mt-8 mb-2">
                ⚠ Suspicious Payments
            </h2>

            {data.suspicious?.length === 0 ? (
                <p className="text-gray-500">No suspicious payments found.</p>
            ) : (
                data.suspicious?.map((s) => (
                    <div key={s.id} className="border p-3 bg-red-50 mb-2 rounded">
                        <p><b>ID:</b> {s.id}</p>
                        <p><b>Amount:</b> {s.amount} EUR</p>
                        <p><b>Reason:</b> {s.reason}</p>
                    </div>
                ))
            )}
            <table className="w-full border text-sm">
                <thead>
                    <tr className="bg-gray-100">
                        <th>Month</th>
                        <th>Revenue</th>
                        <th>Payments</th>
                    </tr>
                </thead>
                <tbody>
                    {data.monthly?.map((m) => (
                        <tr key={m.month} className="border-t">
                            <td>{m.month}</td>
                            <td>{m.revenue} EUR</td>
                            <td>{m.count}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}